import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPipelineInProgress = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		opacity: .4,
		d: "M7.15494 16.5C6.37605 16.3306 5.62788 16.0515 4.93501 15.672M10.7355 1.5C12.5151 1.88801 14.1041 2.84131 15.2422 4.20383C16.3802 5.56636 17 7.25736 17 9C17 10.7426 16.3802 12.4336 15.2422 13.7962C14.1041 15.1587 12.5151 16.112 10.7355 16.5M2.30242 13.352C1.81465 12.6745 1.44384 11.9267 1.20409 11.1371M1 7.71824C1.14322 6.90646 1.41892 6.1374 1.80562 5.43244L1.9569 5.17181M4.38629 2.65871C5.22431 2.10916 6.16373 1.716 7.15494 1.5",
		stroke: "black",
		strokeWidth: 2.01405,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPipelineInProgress;
